import { render, staticRenderFns } from "./CustomerHeader.vue?vue&type=template&id=47c49ad0&scoped=true&lang=pug&"
import script from "./CustomerHeader.vue?vue&type=script&lang=ts&"
export * from "./CustomerHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerHeader.vue?vue&type=style&index=0&id=47c49ad0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c49ad0",
  null
  
)

export default component.exports